import React from 'react';
import { Message } from '@forwardfinancing/component-library';

const SomethingWentWrongMessage = () => {
  const route = "https://www.forwardfinancing.com";
  return (
    <div className="something-went-wrong container page">
      <div className="nav-left">
        <a href={route} className="nav-item is-brand">
            <img
              src="https://commonassets.forwardfinancing.com/media/newLogo.png"
              alt="Forward Financing Logo"
              width="270"
              height="90"
            />
        </a>
      </div>
      <div className="something-went-wrong--message">
        <Message
          mainMessage="Please Try Again Later"
          secondaryMessage="Something has gone wrong."
          buttonDisplayVal="Forward Financing Home"
          buttonLink={route}
        />
      </div>
    </div>
  );
};

export default SomethingWentWrongMessage;
